import { createContext, useContext } from 'react';

export const DatabaseSnapshotContext = createContext({} as { unsubscribeDatabaseSnapshot: any, setDatabaseSnapshot: Function });

export const useDatabaseSnapshot = () => useContext(DatabaseSnapshotContext);

export default useDatabaseSnapshot;
